import { BetonOrderCalcResult, BetonOrderFormInitialData } from '@beton/const';
import { HttpErrorModel, StateUtils } from '@spartacus/core';

export const BETON_FEATURE = 'beton';
export const BETON_ORDER_INITIALIZATION = '[Beton] Order initialization';
export const BETON_ORDER_CALCULATION = '[Beton] Order calculation';
export const BETON_ORDER_CONFIRMATION = '[Beton] Order confirmation';

export interface BetonState {
  initialData: StateUtils.LoaderState<BetonOrderFormInitialData>;
  calculateOrder: StateUtils.LoaderState<BetonOrderCalcResult>;
  calculateOrderError: HttpErrorModel;
  confirmOrder: StateUtils.LoaderState<unknown>;
  confirmOrderError: HttpErrorModel;
}

export interface StateWithBeton {
  [BETON_FEATURE]: BetonState;
}
